/**
 * The confirmation profiles map the add button profiles to properties to be used on the confirmation bar.
 *
 * When an add button is invoked, it is given a profile, e.g. playlist, or track. When the confirmation bar is
 * shown, it is populated using the properties in this file for that particular profile. The text is used as the
 * link text, the url is the url for this link, and the action is used for istats.
 */
define('plugins/musicfavourite/ui/confirmationProfiles',{
    'playlister': {
        'default': {
            'text': 'My Tracks',
            'url': '/music/tracks/my'
        }
    },
    'track': {
        'default': {
            'text': 'My Tracks',
            'url': '/music/tracks/my'
        }
    },
    'artist': {
        'default': {
            'text': 'My Artists',
            'url': '/music/artists/my'
        }
    },
    'playlist': {
        'default': {
            'text': 'My Playlists',
            'url': '/music/playlists/my'
        }
    },
    'audiovideo': {
        'default': {
            'text': 'My Audio & Video',
            'url': '/music/performances/my'
        },
        'PERFORMANCE': {
            'text': 'My Audio & Video',
            'url': '/music/performances/my'
        },
        'INTERVIEW': {
            'text': 'My Audio & Video',
            'url': '/music/interviews/my'
        }
    },
    'radio': {
        'default': {
            'text': 'My Radio',
            'url': '/radio/favourites/programmes',
            'imageRecipe': '160x160'
        },
        'tlec': {
            'text': 'My Radio',
            'url': '/radio/favourites/programmes',
            'imageRecipe': '160x160'
        },
        'programme': {
            'text': 'My Radio',
            'url': '/radio/favourites/episodesandclips',
            'imageRecipe': '160x90'
        }
    }
});
